import HasCarBeenSoldPage from "./HasCarBeenSoldPage"

export default HasCarBeenSoldPage
